// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Icon from '@ff/ui/Icon';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  label: string,
  url: string,
  icon: string,
  openInNewTab: Boolean
};

function StyledButton({ label, icon, url, openInNewTab, classes: c }: Props) {
  return (
    <a className={c.container} href={url} target={openInNewTab && '_blank'} rel="noopener noreferrer">
      <div className={c.label}>
        {label}
        {icon && (
          <Icon name={icon} className={c.icon} />
        )}
      </div>
    </a>
  );
}

const styles = {
  container: {
    fontFamily: FONT_FAMILY_ROBOTO,
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    paddingBottom: '12px',
    textDecoration: 'none',
    lineHeight: '1em',
    fontSize: '14px',
    letterSpacing: '0.8px',
    textAlign: 'center',
    '@media(max-width: 960px)': {
      width: '100%'
    }
  },
  icon: {
    marginLeft: '5px'
  },
  label: {
    padding: '9px 31px',
    backgroundColor: 'black',
    border: '1px solid white',
    color: 'white',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '28px',
    transition: 'all .25s ease-in',
    letterSpacing: '1.2',
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'white',
    },
    '@media(max-width: 960px)': {
      width: '100%',
      textAlign: 'center'
    }
  }
};

export default injectSheet(styles)(StyledButton);
